module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+=''+
((__t=(t('community::share-menu:empty')))==null?'':_.escape(__t))+
'';
}
return __p;
};